// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZUShcU {
  padding: 0;
  background: var(--text-neutral-pale);
  width: 100%;
  box-sizing: border-box;
}

.zSezBu {
  margin: 0;
  padding: var(--spacing-4) var(--spacing-3);
  background: var(--surface-neutral-subtle);
  border-radius: var(--card-border-radius);
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-4);
}

.e2vz2K {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
  min-width: 0;
}

.DDID1a {
  display: flex;
  flex-direction: column;
  gap: 0;
  font-size: var(--font-size-3xl);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-100);
  margin: 0;
  color: var(--text-neutral-dark);
  font-family: var(--font-family-clario), var(--font-family-base);
}

.gOoeRC {
  display: block;
}

.edleeH {
  color: var(--brand-tr-orange);
  font-weight: var(--font-weight-bold);
}

.ebPGZU {
  margin: 0;
  font-size: var(--font-size-lg);
  line-height: var(--line-height-160);
  font-weight: var(--font-weight-regular);
  color: #000000;
  max-width: 100%;
  font-family: var(--font-family-base);
  overflow-wrap: break-word;
}

.iYkoe0 {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
  --input-fixed-height: 40px;
  --input-v-padding: var(--spacing-1-5);
}

.h2NccI {
  width: 100%;
  min-width: 0;
}

.h2NccI label {
  font-family: var(--font-family-base);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-160);
  color: var(--text-neutral-stronger);
  margin-bottom: 0;
}

.h2NccI p {
  margin: 0;
  font-family: var(--font-family-base);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-160);
  color: var(--text-neutral-stronger);
}

.Ekq3Kc {
  box-sizing: border-box;
  background: var(--surface-neutral-white);
  border-radius: var(--radius-s);
}

.HTcToq {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-0-5);
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

.ArfrI3 {
  line-height: 1;
  min-height: 0;
}

.iYkoe0 .BubfE_ {
  height: 40px;
  min-height: 40px;
  max-height: 40px;
  line-height: 1;
  padding: var(--spacing-1-5) var(--spacing-1-5);
  padding-right: 40px;
  box-sizing: border-box;
  background: var(--surface-neutral-white);
  border-radius: var(--radius-s);
  font-size: var(--font-size-md);
}

.iYkoe0 .BubfE_ > span:first-of-type {
  line-height: 1;
  font-size: var(--font-size-md);
}

.T609qs {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--spacing-3);
  align-items: start;
}

.fVPC9M {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: var(--spacing-3);
  align-items: flex-start;
  width: 100%;
  min-width: 0;
}

.fVPC9M > :first-child {
  flex: 1 1 10rem;
  min-width: 0;
}

.LAgmzg {
  flex-shrink: 0;
}

.iYkoe0 .fVPC9M .LAgmzg,
.iYkoe0 .fVPC9M .LAgmzg.bEUIDI:disabled {
  height: 40px;
  min-height: 40px;
  max-height: 40px;
  box-sizing: border-box;
  padding: 0 var(--spacing-2);
  align-self: flex-start;
  margin-top: calc(var(--font-size-sm) * 1.6 + var(--spacing-0-5, 4px));
}

.iYkoe0 .LAgmzg.bEUIDI:disabled {
  cursor: wait;
  opacity: 1;
  background: var(--surface-neutral-white);
  border-color: var(--text-primary-medium);
  --button-text-color: var(--text-primary-medium);
}

.u60BFN input[type='number'] {
  appearance: textfield;
  -moz-appearance: textfield;
}

.u60BFN input[type='number']::-webkit-outer-spin-button,
.u60BFN input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

@media (max-width: 768px) {
  .T609qs {
    grid-template-columns: 1fr;
  }

  .fVPC9M {
    flex-direction: column;
    align-items: stretch;
  }

  .LAgmzg {
    width: 100%;
  }

  .iYkoe0 .fVPC9M .LAgmzg,
  .iYkoe0 .fVPC9M .LAgmzg.bEUIDI:disabled {
    margin-top: 0;
  }
}

.vWDjbc {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  gap: var(--spacing-4);
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

.qTab0p .jxKADA {
  color: var(--status-error);
}

.qUSLRL {
  display: flex;
  flex-direction: column;
  align-self: stretch;
  gap: var(--spacing-3);
}

.jxKADA {
  margin: 0;
  font-size: var(--font-size-3xl);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-100);
  color: var(--text-neutral-dark);
  font-family: var(--font-family-clario), var(--font-family-base);
  text-align: left;
}

._8HO_Xv {
  margin: 0;
  font-size: var(--font-size-lg);
  line-height: var(--line-height-160);
  font-weight: var(--font-weight-regular);
  color: #000000;
  font-family: var(--font-family-base);
  text-align: left;
}

.EYHI9Z {
  align-self: flex-start;
  height: 40px;
  min-height: 40px;
  max-height: 40px;
  box-sizing: border-box;
  padding: 0 var(--spacing-2);
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/InsideSalesBenefitsLanding/components/InsideSalesContactRequestSection/InsideSalesContactRequestSection.module.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,oCAAoC;EACpC,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,0CAA0C;EAC1C,yCAAyC;EACzC,wCAAwC;EACxC,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,+BAA+B;EAC/B,sCAAsC;EACtC,mCAAmC;EACnC,SAAS;EACT,+BAA+B;EAC/B,+DAA+D;AACjE;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,mCAAmC;EACnC,uCAAuC;EACvC,cAAc;EACd,eAAe;EACf,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,mCAAmC;EACnC,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,mCAAmC;EACnC,mCAAmC;AACrC;;AAEA;EACE,sBAAsB;EACtB,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,8CAA8C;EAC9C,mBAAmB;EACnB,sBAAsB;EACtB,wCAAwC;EACxC,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,2BAA2B;EAC3B,sBAAsB;EACtB,qEAAqE;AACvE;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,wCAAwC;EACxC,wCAAwC;EACxC,+CAA+C;AACjD;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,sCAAsC;EACtC,mCAAmC;EACnC,+BAA+B;EAC/B,+DAA+D;EAC/D,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,mCAAmC;EACnC,uCAAuC;EACvC,cAAc;EACd,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,2BAA2B;AAC7B","sourcesContent":[".outer {\n  padding: 0;\n  background: var(--text-neutral-pale);\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.section {\n  margin: 0;\n  padding: var(--spacing-4) var(--spacing-3);\n  background: var(--surface-neutral-subtle);\n  border-radius: var(--card-border-radius);\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-4);\n}\n\n.intro {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3);\n  min-width: 0;\n}\n\n.headline {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  font-size: var(--font-size-3xl);\n  font-weight: var(--font-weight-medium);\n  line-height: var(--line-height-100);\n  margin: 0;\n  color: var(--text-neutral-dark);\n  font-family: var(--font-family-clario), var(--font-family-base);\n}\n\n.headlineLine {\n  display: block;\n}\n\n.headlineHighlight {\n  color: var(--brand-tr-orange);\n  font-weight: var(--font-weight-bold);\n}\n\n.subtitle {\n  margin: 0;\n  font-size: var(--font-size-lg);\n  line-height: var(--line-height-160);\n  font-weight: var(--font-weight-regular);\n  color: #000000;\n  max-width: 100%;\n  font-family: var(--font-family-base);\n  overflow-wrap: break-word;\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3);\n  --input-fixed-height: 40px;\n  --input-v-padding: var(--spacing-1-5);\n}\n\n.landingField {\n  width: 100%;\n  min-width: 0;\n}\n\n.landingField label {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-regular);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-stronger);\n  margin-bottom: 0;\n}\n\n.landingField p {\n  margin: 0;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-regular);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-stronger);\n}\n\n.landingInputBox {\n  box-sizing: border-box;\n  background: var(--surface-neutral-white);\n  border-radius: var(--radius-s);\n}\n\n.landingDropdownRoot {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-0-5);\n  width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n}\n\n.landingInputControl {\n  line-height: 1;\n  min-height: 0;\n}\n\n.form .landingUfTrigger {\n  height: 40px;\n  min-height: 40px;\n  max-height: 40px;\n  line-height: 1;\n  padding: var(--spacing-1-5) var(--spacing-1-5);\n  padding-right: 40px;\n  box-sizing: border-box;\n  background: var(--surface-neutral-white);\n  border-radius: var(--radius-s);\n  font-size: var(--font-size-md);\n}\n\n.form .landingUfTrigger > span:first-of-type {\n  line-height: 1;\n  font-size: var(--font-size-md);\n}\n\n.formGrid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: var(--spacing-3);\n  align-items: start;\n}\n\n.collabSubmit {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  gap: var(--spacing-3);\n  align-items: flex-start;\n  width: 100%;\n  min-width: 0;\n}\n\n.collabSubmit > :first-child {\n  flex: 1 1 10rem;\n  min-width: 0;\n}\n\n.submitBtn {\n  flex-shrink: 0;\n}\n\n.form .collabSubmit .submitBtn,\n.form .collabSubmit .submitBtn.submitBtnLoading:disabled {\n  height: 40px;\n  min-height: 40px;\n  max-height: 40px;\n  box-sizing: border-box;\n  padding: 0 var(--spacing-2);\n  align-self: flex-start;\n  margin-top: calc(var(--font-size-sm) * 1.6 + var(--spacing-0-5, 4px));\n}\n\n.form .submitBtn.submitBtnLoading:disabled {\n  cursor: wait;\n  opacity: 1;\n  background: var(--surface-neutral-white);\n  border-color: var(--text-primary-medium);\n  --button-text-color: var(--text-primary-medium);\n}\n\n.numberFieldInput input[type='number'] {\n  appearance: textfield;\n  -moz-appearance: textfield;\n}\n\n.numberFieldInput input[type='number']::-webkit-outer-spin-button,\n.numberFieldInput input[type='number']::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n@media (max-width: 768px) {\n  .formGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .collabSubmit {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .submitBtn {\n    width: 100%;\n  }\n\n  .form .collabSubmit .submitBtn,\n  .form .collabSubmit .submitBtn.submitBtnLoading:disabled {\n    margin-top: 0;\n  }\n}\n\n.feedbackPanel {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  align-self: stretch;\n  gap: var(--spacing-4);\n  width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n}\n\n.feedbackPanelError .feedbackTitle {\n  color: var(--status-error);\n}\n\n.feedbackCopy {\n  display: flex;\n  flex-direction: column;\n  align-self: stretch;\n  gap: var(--spacing-3);\n}\n\n.feedbackTitle {\n  margin: 0;\n  font-size: var(--font-size-3xl);\n  font-weight: var(--font-weight-medium);\n  line-height: var(--line-height-100);\n  color: var(--text-neutral-dark);\n  font-family: var(--font-family-clario), var(--font-family-base);\n  text-align: left;\n}\n\n.feedbackBody {\n  margin: 0;\n  font-size: var(--font-size-lg);\n  line-height: var(--line-height-160);\n  font-weight: var(--font-weight-regular);\n  color: #000000;\n  font-family: var(--font-family-base);\n  text-align: left;\n}\n\n.feedbackAction {\n  align-self: flex-start;\n  height: 40px;\n  min-height: 40px;\n  max-height: 40px;\n  box-sizing: border-box;\n  padding: 0 var(--spacing-2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"outer": `ZUShcU`,
	"section": `zSezBu`,
	"intro": `e2vz2K`,
	"headline": `DDID1a`,
	"headlineLine": `gOoeRC`,
	"headlineHighlight": `edleeH`,
	"subtitle": `ebPGZU`,
	"form": `iYkoe0`,
	"landingField": `h2NccI`,
	"landingInputBox": `Ekq3Kc`,
	"landingDropdownRoot": `HTcToq`,
	"landingInputControl": `ArfrI3`,
	"landingUfTrigger": `BubfE_`,
	"formGrid": `T609qs`,
	"collabSubmit": `fVPC9M`,
	"submitBtn": `LAgmzg`,
	"submitBtnLoading": `bEUIDI`,
	"numberFieldInput": `u60BFN`,
	"feedbackPanel": `vWDjbc`,
	"feedbackPanelError": `qTab0p`,
	"feedbackTitle": `jxKADA`,
	"feedbackCopy": `qUSLRL`,
	"feedbackBody": `_8HO_Xv`,
	"feedbackAction": `EYHI9Z`
};
module.exports = ___CSS_LOADER_EXPORT___;
